const CVV_BOTTOM_SHEET = "cvv_bottom_sheet";

export const CVV_BOTTOM_SHEET_TEST_IDS = {
    CONTAINER: `${CVV_BOTTOM_SHEET}_container`,
    TITLE: `${CVV_BOTTOM_SHEET}_title`,
    PAY_BUTTON: `${CVV_BOTTOM_SHEET}_pay_button`,
};
